"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DialogActions: function() {
        return _DialogActions.DialogActions;
    },
    dialogActionsClassNames: function() {
        return _useDialogActionsStylesstyles.dialogActionsClassNames;
    },
    renderDialogActions_unstable: function() {
        return _renderDialogActions.renderDialogActions_unstable;
    },
    useDialogActionsStyles_unstable: function() {
        return _useDialogActionsStylesstyles.useDialogActionsStyles_unstable;
    },
    useDialogActions_unstable: function() {
        return _useDialogActions.useDialogActions_unstable;
    }
});
const _DialogActions = require("./DialogActions");
const _renderDialogActions = require("./renderDialogActions");
const _useDialogActions = require("./useDialogActions");
const _useDialogActionsStylesstyles = require("./useDialogActionsStyles.styles");
